// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 기업 검색 컴포넌트 스타일 */
.company-search {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
}

.search-header {
  padding: 1rem 1rem 0.75rem 1rem;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
}

.search-header h3 {
  margin: 0 0 0.25rem 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
}

.search-stats {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 500;
}

.search-controls {
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.search-input-group {
  position: relative;
  margin-bottom: 0.75rem;
}

.search-input {
  width: 100%;
  padding: 0.75rem 2rem 0.75rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  background: white;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.clear-search-btn {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #adb5bd;
  cursor: pointer;
  font-size: 0.75rem;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.clear-search-btn:hover {
  background: #e9ecef;
  color: #495057;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.filter-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #495057;
  white-space: nowrap;
}

.manager-select {
  flex: 1 1;
  min-width: 0;   /* 같은 행의 '모두 보기' 버튼을 위해 줄어들 수 있도록 */
  padding: 0.5rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
  transition: border-color 0.2s ease;
}

.manager-select:focus {
  outline: none;
  border-color: #007bff;
}

/* '모두 보기' 버튼 (Login.css 전역 button 누수 방지: width/색상 명시) */
.manager-showall-btn {
  flex: 0 0 auto;
  width: auto;
  padding: 0.5rem 0.7rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
  color: #495057;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.manager-showall-btn:hover {
  background: #eef1fb;
  border-color: #b8c0ff;
}

.manager-showall-btn.active {
  background: #007bff;
  border-color: #007bff;
  color: #fff;
}

.company-results {
  flex: 1 1;
  min-height: 0; /* flex 자식이 부모 높이를 넘지 않도록 — 내부 스크롤 활성화 */
  overflow-y: auto;
  overscroll-behavior: contain; /* 목록 끝에서 스크롤이 오른쪽 화면으로 번지지 않게 */
  padding: 0.75rem 1rem;
}

/* 드래그 가능한 스크롤바 표시 */
.company-results::-webkit-scrollbar {
  width: 10px;
}

.company-results::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 5px;
}

.company-results::-webkit-scrollbar-thumb {
  background: #adb5bd;
  border-radius: 5px;
  border: 2px solid #f1f3f5;
}

.company-results::-webkit-scrollbar-thumb:hover {
  background: #868e96;
}

.company-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.company-item {
  padding: 0.75rem 1rem;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: white;
  transition: all 0.2s ease;
  cursor: pointer;
  margin-bottom: 0.5rem;
}

.company-item:hover {
  border-color: #007bff;
  background: #f8f9fa;
}

.company-item.selected {
  border-color: #007bff;
  background: linear-gradient(135deg, #e3f2fd, #f3e5f5);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
}

.company-content {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.company-content-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.company-manager {
  background: #007bff;
  color: white;
  padding: 0.15rem 0.4rem;
  border-radius: 8px;
  font-size: 0.7rem;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.company-name {
  font-weight: 600;
  color: #212529;
  font-size: 0.85rem;
  flex: 1 1;
}

.company-alt-name {
  color: #6c757d;
  font-style: italic;
  font-size: 0.7rem;
}

.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  color: #6c757d;
}

.no-results-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.no-results p {
  margin: 0.5rem 0;
  font-size: 1rem;
}

.no-results-hint {
  font-size: 0.85rem !important;
  color: #adb5bd;
}

.add-company-section {
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

.add-company-btn {
  width: 100%;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.add-company-btn:hover {
  background: linear-gradient(135deg, #20c997, #17a2b8);

  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.add-icon {
  font-size: 1.2rem;
  font-weight: bold;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .search-header {
    padding: 0.75rem;
  }
  
  .search-controls {
    padding: 0.5rem 0.75rem;
  }
  
  .company-results {
    padding: 0.5rem 0.75rem;
  }
  
  .company-item {
    padding: 0.5rem 0.6rem;
  }
  
  
  .company-manager {
    font-size: 0.65rem;
    padding: 0.1rem 0.3rem;
  }
  
  .company-name {
    font-size: 0.8rem;
  }
  
  .company-alt-name {
    font-size: 0.65rem;
  }
  
  .filter-group {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .filter-label {
    font-size: 0.85rem;
  }
  
  .add-company-section {
    padding: 0.75rem;
  }
}

@media (max-width: 480px) {
  .search-header h3 {
    font-size: 1.1rem;
  }
  
  .search-stats {
    font-size: 0.8rem;
  }
  
  .company-name {
    font-size: 0.75rem;
  }
  
  .company-alt-name {
    font-size: 0.6rem;
  }
  
  .company-manager {
    font-size: 0.6rem;
    padding: 0.08rem 0.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CompanySearch.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY,IAAI,mCAAmC;EACnD,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa,EAAE,wCAAwC;EACvD,gBAAgB;EAChB,4BAA4B,EAAE,gCAAgC;EAC9D,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qDAAqD;;EAErD,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;;EAGA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;AACF","sourcesContent":["/* 기업 검색 컴포넌트 스타일 */\r\n.company-search {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background: white;\r\n}\r\n\r\n.search-header {\r\n  padding: 1rem 1rem 0.75rem 1rem;\r\n  border-bottom: 1px solid #e9ecef;\r\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\r\n}\r\n\r\n.search-header h3 {\r\n  margin: 0 0 0.25rem 0;\r\n  color: #495057;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.search-stats {\r\n  font-size: 0.75rem;\r\n  color: #6c757d;\r\n  font-weight: 500;\r\n}\r\n\r\n.search-controls {\r\n  padding: 0.75rem 1rem;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.search-input-group {\r\n  position: relative;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  padding: 0.75rem 2rem 0.75rem 1rem;\r\n  border: 2px solid #e9ecef;\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n  transition: all 0.2s ease;\r\n  background: white;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\r\n}\r\n\r\n.clear-search-btn {\r\n  position: absolute;\r\n  right: 0.5rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  color: #adb5bd;\r\n  cursor: pointer;\r\n  font-size: 0.75rem;\r\n  padding: 0;\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.clear-search-btn:hover {\r\n  background: #e9ecef;\r\n  color: #495057;\r\n}\r\n\r\n.filter-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.filter-label {\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  color: #495057;\r\n  white-space: nowrap;\r\n}\r\n\r\n.manager-select {\r\n  flex: 1;\r\n  min-width: 0;   /* 같은 행의 '모두 보기' 버튼을 위해 줄어들 수 있도록 */\r\n  padding: 0.5rem 0.75rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  background: white;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.manager-select:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n}\r\n\r\n/* '모두 보기' 버튼 (Login.css 전역 button 누수 방지: width/색상 명시) */\r\n.manager-showall-btn {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  padding: 0.5rem 0.7rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  color: #495057;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.manager-showall-btn:hover {\r\n  background: #eef1fb;\r\n  border-color: #b8c0ff;\r\n}\r\n\r\n.manager-showall-btn.active {\r\n  background: #007bff;\r\n  border-color: #007bff;\r\n  color: #fff;\r\n}\r\n\r\n.company-results {\r\n  flex: 1;\r\n  min-height: 0; /* flex 자식이 부모 높이를 넘지 않도록 — 내부 스크롤 활성화 */\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain; /* 목록 끝에서 스크롤이 오른쪽 화면으로 번지지 않게 */\r\n  padding: 0.75rem 1rem;\r\n}\r\n\r\n/* 드래그 가능한 스크롤바 표시 */\r\n.company-results::-webkit-scrollbar {\r\n  width: 10px;\r\n}\r\n\r\n.company-results::-webkit-scrollbar-track {\r\n  background: #f1f3f5;\r\n  border-radius: 5px;\r\n}\r\n\r\n.company-results::-webkit-scrollbar-thumb {\r\n  background: #adb5bd;\r\n  border-radius: 5px;\r\n  border: 2px solid #f1f3f5;\r\n}\r\n\r\n.company-results::-webkit-scrollbar-thumb:hover {\r\n  background: #868e96;\r\n}\r\n\r\n.company-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.company-item {\r\n  padding: 0.75rem 1rem;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 6px;\r\n  background: white;\r\n  transition: all 0.2s ease;\r\n  cursor: pointer;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.company-item:hover {\r\n  border-color: #007bff;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.company-item.selected {\r\n  border-color: #007bff;\r\n  background: linear-gradient(135deg, #e3f2fd, #f3e5f5);\r\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);\r\n}\r\n\r\n.company-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.15rem;\r\n}\r\n\r\n.company-content-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.company-manager {\r\n  background: #007bff;\r\n  color: white;\r\n  padding: 0.15rem 0.4rem;\r\n  border-radius: 8px;\r\n  font-size: 0.7rem;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.company-name {\r\n  font-weight: 600;\r\n  color: #212529;\r\n  font-size: 0.85rem;\r\n  flex: 1;\r\n}\r\n\r\n.company-alt-name {\r\n  color: #6c757d;\r\n  font-style: italic;\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.no-results {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3rem 1rem;\r\n  text-align: center;\r\n  color: #6c757d;\r\n}\r\n\r\n.no-results-icon {\r\n  font-size: 3rem;\r\n  margin-bottom: 1rem;\r\n  opacity: 0.5;\r\n}\r\n\r\n.no-results p {\r\n  margin: 0.5rem 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n.no-results-hint {\r\n  font-size: 0.85rem !important;\r\n  color: #adb5bd;\r\n}\r\n\r\n.add-company-section {\r\n  padding: 1rem;\r\n  border-top: 1px solid #e9ecef;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.add-company-btn {\r\n  width: 100%;\r\n  padding: 0.75rem 1rem;\r\n  background: linear-gradient(135deg, #28a745, #20c997);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.add-company-btn:hover {\r\n  background: linear-gradient(135deg, #20c997, #17a2b8);\r\n\r\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.add-icon {\r\n  font-size: 1.2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 768px) {\r\n  .search-header {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .search-controls {\r\n    padding: 0.5rem 0.75rem;\r\n  }\r\n  \r\n  .company-results {\r\n    padding: 0.5rem 0.75rem;\r\n  }\r\n  \r\n  .company-item {\r\n    padding: 0.5rem 0.6rem;\r\n  }\r\n  \r\n  \r\n  .company-manager {\r\n    font-size: 0.65rem;\r\n    padding: 0.1rem 0.3rem;\r\n  }\r\n  \r\n  .company-name {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .company-alt-name {\r\n    font-size: 0.65rem;\r\n  }\r\n  \r\n  .filter-group {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .filter-label {\r\n    font-size: 0.85rem;\r\n  }\r\n  \r\n  .add-company-section {\r\n    padding: 0.75rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .search-header h3 {\r\n    font-size: 1.1rem;\r\n  }\r\n  \r\n  .search-stats {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .company-name {\r\n    font-size: 0.75rem;\r\n  }\r\n  \r\n  .company-alt-name {\r\n    font-size: 0.6rem;\r\n  }\r\n  \r\n  .company-manager {\r\n    font-size: 0.6rem;\r\n    padding: 0.08rem 0.25rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
